(function (upp) {
    'use strict';

    upp.controller('upp.restaurant.FoodCtrl', ['$scope', '$routeParams', 'restaurantService', 'cartService', 'appi',
            function ($scope, $routeParams, restaurantService, cartService, appi) {


                appi.ui.showPageLoadingMsg();

                $scope.selectedVariation = {};

                restaurantService.getFood($routeParams.id).then(function(data) {
                    $scope.food = data;
                    $scope.currency = data.currency;
                    $scope.addToBasket = data.addToBasket;

                    appi.ui.changeActualOption({i18n: 'RESTAURANT.GO-BACK-CATEGORY'}, '/restaurant/' + data.category.id);
                    appi.ui.hidePageLoadingMsg();
                });

                $scope.checkAdd2Cart = function () {
                   return !$scope.selectedVariation || !$scope.selectedVariation.id;
                };

                $scope.add2cart = function () {
                    $scope.food.selectedVariation = $scope.selectedVariation;
                    $scope.food.selectedVariation.priceFinal = $scope.selectedVariation.price;
                    cartService.add($scope.food, $scope.currency);
                };
            }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/restaurant/controllers/food-controller.js